<template>
    <section class="lightbox">
      <button class="cross" @click="closeModal">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 47.971 47.971"
          style="enable-background:new 0 0 47.971 47.971;"
          xml:space="preserve"
        >
          <path
            d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
		c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
		C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
		s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"
          />
        </svg>
      </button>
      <div class="slideshow">
        <button class="arrow arrow-left" @click="updateIndex(-1)">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="451.846px"
            height="451.847px"
            viewBox="0 0 451.846 451.847"
            style="enable-background:new 0 0 451.846 451.847;"
          >
            <path
              d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
            />
          </svg>
        </button>
        <div class="displayed-content">

            <div class="displayed-image">
              <transition name="fade" mode="out-in">
              <img :src="displayImage" :alt="title" :key="displayImage" />
          </transition>
              <div class="banner">
                <h1>{{ title }}</h1>
                <p>{{ description }}</p>
              </div>
            </div>

        </div>
        <button class="arrow" @click="updateIndex(1)">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="451.846px"
            height="451.847px"
            viewBox="0 0 451.846 451.847"
            style="enable-background:new 0 0 451.846 451.847;"
          >
            <path
              d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
            />
          </svg>
        </button>
        <div class="bullets">
          <ul class="d-flex">
            <li
              v-for="(property, index) in properties"
              :key="property.id"
              class="bullet"
              :class="currentIndex === index ? 'active' : ''"
            >
              <button @click="changeSlide(index)"></button>
            </li>
          </ul>
        </div>
      </div>
    </section>
</template>
<script>
import EventBus from "@/bus/modal-bus";

export default {
  props: {},
  data() {
    return {
      currentIndex: 0,
      title: "",
      description: "",
      properties: [],
    };
  },
  methods: {
    closeModal() {
      EventBus.$emit("change_modal", {
        modal: false,
      });
    },
    changeSlide(index) {
      this.currentIndex = index;
    },
    updateIndex(sign) {
      if (sign === 1) {
        this.currentIndex = (this.currentIndex + 1) % this.properties.length;
      } else if (sign === -1) {
        this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.properties.length - 1;
      }
    },
  },
  computed: {
    displayImage() {
      if (this.properties[this.currentIndex] !== undefined) {
        console.log(this._global.rServer + "s/real/1200/" + this.properties[this.currentIndex].url);
        return this._global.rServer + "s/real/1200/" + this.properties[this.currentIndex].url;
      }
      return "";
    },
  },
  created() {
    EventBus.$on("change_modal", (properties) => {
      if (properties.modal) {
        this.properties = properties.properties[0].images;
        this.title = properties.properties[0].title;
        this.description = properties.properties[0].description;
        this.currentIndex = 0;
      }
    });
  },
};
</script>

<style>
.fade-enter,
.fade-leave,
.fade-leave-active {
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.4s ease;
}

.fade-enter-active,
.fade-leave-active {
  transform: scale(1);
  transition: all 0.4s ease;
}
</style>
